export default __webpack_public_path__ + "images/255e5f1bd036a43106f8126d21daf6f3.svg";